import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';

export interface AzureAdConfig {
    clientId: string;
    authority: string;
    redirectUri: string;
    cacheLocation: string;
    storeAuthStateInCookie: boolean;
    scopes: string[];
}

@Injectable()
export class ConfigService {
    private configData: AzureAdConfig;

    constructor(private http: Http) { }

    loadConfig(): Promise<void> {
        const env = this.getEnvironmentName();
        const configPath = `./shared-assets/AzureAd.${env}.json`;
        return this.http.get(configPath)
            .toPromise()
            .then((response: Response) => {
                const data = response.json();
                this.configData = data.azureAd; // assuming the JSON has { "azureAd": { ... } }
            })
            .catch((error: any) => {
                console.error('Could not load configuration', error);
                return Promise.reject(error);
            });
    }

    getConfig(): AzureAdConfig {
        if (!this.configData) {
            throw new Error('Config not loaded yet!');
        }
        return this.configData;
    }
    private getEnvironmentName(): string {
        const host = window.location.host.toLowerCase();

        if (host.includes('localhost')) {
            return 'localhost';
        } else if (host.includes('wonderful-forest-092dc1d0f') || host.includes('forms-dev.control4.com')) {
            return 'dev';
        } else {
            return 'prod';
        }
    }
}
